class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Only use hover for desktop (outside of drawer)
    // Check if we are inside the mobile drawer
    this.isInsideDrawer = !!this.closest('#menu-drawer');

    if (!this.isInsideDrawer) {
      // Desktop behavior: hover to open/close
      this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      // Prevent click from navigating on desktop (we use hover)
      this.querySelector('summary').addEventListener('click', (e) => e.preventDefault());
    } else {
      // Mobile drawer behavior: click to toggle
      this.querySelector('summary').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = this.mainDetailsToggle.hasAttribute('open');

        if (isOpen) {
          // Close
          this.mainDetailsToggle.classList.remove('menu-opening');
          this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
          setTimeout(() => {
            this.mainDetailsToggle.removeAttribute('open');
          }, 300);
        } else {
          // Open
          this.mainDetailsToggle.setAttribute('open', '');
          this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
          requestAnimationFrame(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
          });
        }
      });
    }
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    this.close();
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

